import React from "react";
import EmailLogin from "../../components/auth/EmailLogin";

const LoginPage = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 text-onWhite">
      <div className="bg-background rounded-lg shadow-lg w-full max-w-md p-8">
        <EmailLogin></EmailLogin>
      </div>
    </div>
  );
};

export default LoginPage;
